import { GoogleOAuthProvider } from "@react-oauth/google";
import queryString from "query-string";
import React, { useCallback, useEffect } from "react";
import {
	Route,
	BrowserRouter as Router,
	Routes,
	useLocation,
} from "react-router-dom";
import EmailVerification from "./components/auth/EmailVerification";

import Login from "./components/auth/Login";
import LoginModal from "./components/auth/LoginModal";
import ProtectedAdminRoute from "./components/auth/ProtectedAdminRoute";
import RegisterModal from "./components/auth/RegisterModal";
import Registration from "./components/auth/Registration";
import About from "./Pages/About";
import AdminDashboard from "./Pages/AdminDashboard";
import BerninaInfo from "./Pages/BerninaInfo";
import Contact from "./Pages/Contact";
import Homepage from "./Pages/Homepage";
import Profile from "./Pages/Profile";
import QRCodeWelcome from "./Pages/QRCodeWelcome";
import "antd/dist/reset.css";
import UnauthorizedPage from "./Pages/UnauthorizedPage";
import useAuthStore from "./stores/authStore";

const AppContent = () => {
	const location = useLocation();
	const { initialize, googleLogin } = useAuthStore();

	const handleInitialization = useCallback(async () => {
		const values = queryString.parse(location.search);
		const code = values.code;

		if (code) {
			await googleLogin(code);
		} else {
			initialize();
		}
	}, [location.search, initialize, googleLogin]);

	useEffect(() => {
		handleInitialization();
	}, [handleInitialization]);

	return (
		<>
			<Routes>
				<Route path="/" element={<Homepage />} />
				<Route path="/login" element={<Login />} />
				<Route path="/register" element={<Registration />} />
				<Route path="/about" element={<About />} />
				<Route path="/bernina" element={<BerninaInfo />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/profile" element={<Profile />} />
				<Route path="/welcome/*" element={<QRCodeWelcome />} />
				<Route
					path="/AdminDashboard/*"
					element={
						<ProtectedAdminRoute>
							<AdminDashboard />
						</ProtectedAdminRoute>
					}
				/>
				<Route
					path="/api/auth/register/account-confirm-email/:key"
					element={<EmailVerification />}
				/>
				<Route path="/verify-email/:token" element={<EmailVerification />} />
				<Route path="/unauthorized" element={<UnauthorizedPage />} />
			</Routes>
		</>
	);
};

const App = () => {
	return (
		<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
			<Router>
				<AppContent />
				<LoginModal />
				<RegisterModal />
			</Router>
		</GoogleOAuthProvider>
	);
};

export default App;
